import React from "react";
import { animationInterval } from "../utils/util";

const NowContext = React.createContext();

/**
 * @param {object} props
 * @param {number} interval - refresh interval in ms
 */
export function NowProvider({ children, interval }) {
  const [now, setNow] = React.useState(new Date());
  React.useEffect(() => {
    const controller = new AbortController();
    animationInterval(interval, controller.signal, () => {
      setNow(new Date());
    });

    return function () {
      controller.abort();
    };
  }, [interval]);

  return <NowContext.Provider value={now}>{children}</NowContext.Provider>;
}

export function useNow() {
  return React.useContext(NowContext);
}
